import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dc2dbfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "conversations" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 2,
  class: "message-loader"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Weitere Konversationen werden geladen...", -1))
const _hoisted_6 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_progress_indicator_linear = _resolveComponent("md-progress-indicator-linear")!
  const _component_conversation = _resolveComponent("conversation")!
  const _component_md_progress_indicator_circular = _resolveComponent("md-progress-indicator-circular")!
  const _component_conversation_loader = _resolveComponent("conversation-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.searchInConversations)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_md_input_field, {
        size: "small",
        error: false,
        modelValue: _ctx.searchPhrase,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchPhrase) = $event)),
        label: "In Konversationen suchen",
        onKeydown: [
          _withKeys(_ctx.searchConversations, ["enter"]),
          _withKeys(_ctx.toggleSearch, ["esc"])
        ],
        ref: "searchInput"
      }, null, 8, ["modelValue", "onKeydown"]), [
        [_vShow, _ctx.searchInConversations]
      ]),
      true
        ? (_openBlock(), _createBlock(_component_md_button, {
            key: 1,
            variant: "icon",
            icon: _ctx.searchInConversations ? 'close' : 'search',
            onClick: _ctx.toggleSearch
          }, null, 8, ["icon", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.searching)
        ? (_openBlock(), _createBlock(_component_md_progress_indicator_linear, {
            key: 2,
            class: "loader"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "list",
      onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onListScroll && _ctx.onListScroll(...args)))
    }, [
      (_ctx.conversations && !_ctx.showSearchResults)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversations, (conversation, k) => {
              return (_openBlock(), _createBlock(_component_conversation, {
                key: k,
                conversation: conversation
              }, null, 8, ["conversation"]))
            }), 128)),
            (!_ctx.searchInConversations && !_ctx.conversationsLoading)
              ? (_openBlock(), _createBlock(_component_md_button, {
                  key: 0,
                  variant: "text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('more')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Weitere laden")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.showSearchResults)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredConversations, (conversation, k) => {
            return (_openBlock(), _createBlock(_component_conversation, {
              key: k,
              conversation: conversation
            }, null, 8, ["conversation"]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.conversationsLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_md_progress_indicator_circular, { size: "small" }),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSearchResults && _ctx.filteredConversations.length <= 0)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_6, " Keine Konversationen gefunden! "))
        : _createCommentVNode("", true),
      (!_ctx.conversations && !_ctx.showSearchResults)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, _renderList(9, (n) => {
            return _createVNode(_component_conversation_loader, { key: n })
          }), 64))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}